import { render } from "./SafeDrivingCardDetailModal.vue?vue&type=template&id=3589dc58&scoped=true"
import script from "./SafeDrivingCardDetailModal.vue?vue&type=script&lang=js"
export * from "./SafeDrivingCardDetailModal.vue?vue&type=script&lang=js"

import "./SafeDrivingCardDetailModal.vue?vue&type=style&index=0&id=3589dc58&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3589dc58"]])

export default __exports__